import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HighlightIconFocus',
  props: {
    fill: {
      type: String,
      default: 'white',
    },
  },
  setup(__props) {

  

return { __sfc: true, }
}

})